import { showSuccessMessage } from '@/notification-utils'

export default {
  methods: {
    copyTextToClipboard(text, successMessage = null) {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text, successMessage)
        return
      }

      navigator.clipboard.writeText(text).then(
        () => {
          if (successMessage) {
            showSuccessMessage(successMessage)
          }
        },
        function(err) {
          console.error('Async: Could not copy text: ', err)
        }
      )
    }
  }
}

function fallbackCopyTextToClipboard(text, successMessage = null) {
  var textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
    if (successMessage) {
      showSuccessMessage(successMessage)
    }
  } catch (err) {
    console.error('unable to copy', err)
  }

  document.body.removeChild(textArea)
}
